import React, { useMemo, useState } from "react";
import { IconButton, LinearProgress, Paper, Button } from "@material-ui/core";
import { makeStyles } from "@material-ui/core/styles";
import DeleteIcon from "@material-ui/icons/Delete";
import EditIcon from "@material-ui/icons/Edit";
import DataTable from "react-data-table-component";
import ArrowDownward from "@material-ui/icons/ArrowDownward";
import { Link } from "react-router-dom";
import VisibilityIcon from "@material-ui/icons/Visibility";
import Dialog from "@material-ui/core/Dialog";
import DialogActions from "@material-ui/core/DialogActions";
import DialogContent from "@material-ui/core/DialogContent";
import DialogContentText from "@material-ui/core/DialogContentText";
import DialogTitle from "@material-ui/core/DialogTitle";

const sortIcon = <ArrowDownward />;

const useStyles = makeStyles((theme) => ({
  paper: {
    marginTop: theme.spacing(3),
    marginBottom: theme.spacing(3),
    padding: theme.spacing(2),
    [theme.breakpoints.up(600 + theme.spacing(3) * 2)]: {
      marginTop: theme.spacing(2),
      marginBottom: theme.spacing(6),
      padding: theme.spacing(3),
    },
    table: {
      minWidth: 650,
    },
  },
  btn: {
    margin: theme.spacing(4),
  },
}));

const StaticPageList = ({
  giftsList = [],
  editGifts,
  deleteGifts,
  check,
  singleGiftsById,
  setOpen,
  open,
  handleClose,
}) => {
  const classes = useStyles();
  const handleClickOpen = () => {
    setOpen(true);
  };
  const safeGifts = Array.isArray(giftsList) ? giftsList : [];

  const [confirmOpenForId, setConfirmOpenForId] = useState(null);

  const handleOpenConfirm = (id) => setConfirmOpenForId(id);
  const handleCloseConfirm = () => setConfirmOpenForId(null);

  const heading = [
    {
      name: "Sr. No",
      wrap: true,
      sortable: true,
      cell: (row, index) => index + 1,
    },
    {
      name: "Title",
      selector: "title",
      wrap: true,
      sortable: true,
    },
    {
      name: "Sub Title",
      selector: "subTitle",
      wrap: true,
      sortable: true,
    },
    //  {
    //     name: "Description",
    //     // selector: "description",
    //     wrap: true,
    //     sortable: true,
    //     // cell:(giftsList)=>(
    //     //     <div>
    //     //         <p>{giftsList.description.toString("markdown")}</p>
    //     //     </div>
    //     // )
    // },
    {
      name: "Action",
      selector: "_id",
      wrap: true,
      center: true,

      cell: (giftsList) => (
        <div>
          <Link to={"/dashboard/add-static/" + giftsList.slug}>
            <IconButton edge="end" aria-label="edit">
              <EditIcon color="primary" />
            </IconButton>
          </Link>
          <Link to={"../pages/" + giftsList.slug}>
            <IconButton edge="end" aria-label="edit">
              <VisibilityIcon color="primary" />
            </IconButton>
          </Link>

          {open && (
            <Dialog
              open={open}
              onClose={handleClose}
              aria-labelledby="alert-dialog-title"
              aria-describedby="alert-dialog-description"
            >
              <DialogTitle id="alert-dialog-title">{"Delete plan"}</DialogTitle>
              <DialogContent>
                <DialogContentText id="alert-dialog-description">
                  Are you sure you want to delete
                </DialogContentText>
              </DialogContent>
              <DialogActions>
                <Button onClick={handleClose} color="primary">
                  No
                </Button>
                <Button
                  onClick={() => {
                    deleteGifts(giftsList._id);
                  }}
                  color="primary"
                  autoFocus
                >
                  Yes
                </Button>
              </DialogActions>
            </Dialog>
          )}
          {/* <IconButton
                        edge="end"
                        aria-label="delete"
                        onClick={handleClickOpen}
                    >
                        <DeleteIcon color="primary"/>
                    </IconButton> */}
        </div>
      ),
    },
  ];

  const columns = useMemo(
    () => [
      {
        name: "Sr. No",
        wrap: true,
        sortable: true,
        // DataTable passes (row, index) for the row index; some table versions pass third arg 'column'
        cell: (row, index) => {
          // index may be undefined in some internals; compute fallback
          if (typeof index === "number") return <div>{index + 1}</div>;
          // If index isn't available, compute from id fallback (not guaranteed order)
          return <div>{safeGifts.findIndex((r) => r._id === row._id) + 1}</div>;
        },
        width: "90px",
      },
      {
        name: "Title",
        selector: (row) => row.title ?? "-", // selector as function is safe
        wrap: true,
        sortable: true,
      },
      {
        name: "Sub Title",
        selector: (row) => row.subTitle ?? "-",
        wrap: true,
        sortable: true,
      },
      {
        name: "Action",
        selector: (row) => row._id,
        wrap: true,
        center: true,
        // cell must return a React node
        cell: (row) => (
          <div style={{ display: "flex", gap: 8, alignItems: "center" }}>
            <Link to={`/dashboard/add-static/${row.slug}`}>
              <IconButton edge="end" aria-label="edit">
                <EditIcon color="primary" />
              </IconButton>
            </Link>

            <Link to={`../pages/${row.slug}`}>
              <IconButton edge="end" aria-label="view">
                <VisibilityIcon color="primary" />
              </IconButton>
            </Link>

            <IconButton
              edge="end"
              aria-label="delete"
              onClick={() => handleOpenConfirm(row._id)}
            >
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="20"
                height="20"
                viewBox="0 0 24 24"
                fill="none"
                stroke="currentColor"
                strokeWidth="2"
                strokeLinecap="round"
                strokeLinejoin="round"
              >
                <polyline points="3 6 5 6 21 6" />
                <path d="M19 6l-1 14a2 2 0 0 1-2 2H8a2 2 0 0 1-2-2L5 6" />
                <path d="M10 11v6" />
                <path d="M14 11v6" />
                <path d="M9 6V4a1 1 0 0 1 1-1h4a1 1 0 0 1 1 1v2" />
              </svg>
            </IconButton>

            {/* Confirmation dialog for the selected row only */}
            {confirmOpenForId === row._id && (
              <Dialog
                open={true}
                onClose={handleCloseConfirm}
                aria-labelledby="confirm-delete-title"
                aria-describedby="confirm-delete-desc"
              >
                <DialogTitle id="confirm-delete-title">Delete page</DialogTitle>
                <DialogContent>
                  <DialogContentText id="confirm-delete-desc">
                    Are you sure you want to delete <b>{row.title}</b>?
                  </DialogContentText>
                </DialogContent>
                <DialogActions>
                  <Button onClick={handleCloseConfirm} color="primary">
                    No
                  </Button>
                  <Button
                    onClick={async () => {
                      try {
                        await deleteGifts(row._id);
                      } catch (err) {
                        console.error("deleteGifts failed:", err);
                      } finally {
                        handleCloseConfirm();
                      }
                    }}
                    color="primary"
                    autoFocus
                  >
                    Yes
                  </Button>
                </DialogActions>
              </Dialog>
            )}
          </div>
        ),
        // make column narrow so actions don't expand too much
        width: "220px",
      },
    ],
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [safeGifts, confirmOpenForId] // stable deps
  );


  const conditionalRowStyles = [
    {
      when: (row) => !row.title,
      style: { backgroundColor: "rgba(255,235,238,0.6)" },
    },
  ];
  return (
    <div>
      {!giftsList ? (
        <LinearProgress color="primary" />
      ) : (
        <Paper className={classes.paper} square>
          {check ? (
            <>
              {/* <Link to="/dashboard/add-static">
                <Button
                  variant="contained"
                  color="primary"
                  className={classes.btn}
                >
                  Add
                </Button>
              </Link> */}
              <DataTable
                columns={columns}
                data={safeGifts}
                noHeader={true}
                pagination
                paginationRowsPerPageOptions={[10, 20, 30, 50, 100]}
                sortIcon={sortIcon}
                striped={true}
                highlightOnHover={true}
                responsive={true}
                conditionalRowStyles={conditionalRowStyles}
              />
            </>
          ) : (
            ""
          )}
        </Paper>
      )}
    </div>
  );
};

export default StaticPageList;
